import React, {useState} from "react";
import Popup from "../../../component/Popup/Popup";
import List from "@mui/material/List";
import DisplayDetailsData from "../../../component/DisplayDetailsData/DisplayDetailsData";
import {statusList, typeList} from "./lists";
import {numberWithPoints} from "../../../utils/numberWithPoints";
import {normalizeTimestemp} from "../../../utils/normalizeTimestemp";
import DownloadButton from "../../../component/DownloadButton/DownloadButton";

//icons
import DownloadIcon from "@mui/icons-material/Download";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EventIcon from "@mui/icons-material/Event";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import LabelImportantIcon from "@mui/icons-material/LabelImportant";
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import HistoryToggleOffIcon from '@mui/icons-material/HistoryToggleOff';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import PersonIcon from '@mui/icons-material/Person';

export default function RecebivelRuralDetails({item, baseUrl}) {

    const [lgShow, setLgShow] = useState(false);


    const title = "Detalhes do Recebível"

    const button = <>
        <VisibilityIcon fontSize="medium"/>
        &nbsp; {title}
    </>


    const iconSpan = <>
        <VisibilityIcon fontSize="large" id="icon-svg"/>
        {title}
    </>

    const handleValor = () => {
        if (item.valorPago == null || item.valorPago === item.valor)
            return 'R$' + numberWithPoints(item.valor)
        else
            return 'R$' + numberWithPoints(item.valor) + ' - pago R$' + numberWithPoints(item.valorPago)
    }


    return (
        <Popup
            buttonText={button}
            title={title}
            iconSpan={iconSpan}
            lgShow={lgShow} setLgShow={setLgShow}
            buttonClass='dropdown-item'
        >
            <List
                sx={{width: '80%', bgcolor: 'background.paper', marginInline: '10%'}}
                component="nav"
                aria-labelledby="nested-list-subheader"
                className='pointer-event'
            >
                <DisplayDetailsData
                    key="primaryData"
                    title='Dados principais'
                    openDefault
                    itens={[
                        {
                            icon: <PersonIcon key="item1"/>,
                            display: `Cliente:  ${item.nomeParticipante} - ${item.documentoParticipante}`,
                        },
                        {
                            icon: <FormatListBulletedIcon key="item2"/>,
                            display: `Tipo:  ${typeList.filter(qtt => qtt.value === item.tipo)[0].label}`
                        },
                        {
                            icon: <PointOfSaleIcon key="item2"/>,
                            display: `Valor: ${handleValor()}`
                        },
                        {
                            icon: <EventIcon key="item2"/>,
                            display: `Vencimento:  ${normalizeTimestemp(item.vencimento)}`
                        },
                        {
                            icon: <EventIcon key="item2"/>,
                            display: `Criado em:  ${normalizeTimestemp(item.dateCreated)}`
                        },
                        {
                            icon: <LabelImportantIcon key="item2"/>,
                            display: `Status:  ${statusList.filter(qtt => qtt.value === item.status)[0].label}`
                        },
                        {
                            icon: <VisibilityIcon key="item2"/>,
                            display: `Observação: ${item.observacao ? item.observacao : 'Não preenchido*'}`
                        },
                        {
                            icon: <DocumentScannerIcon key="item2"/>,
                            display: `DocumentNumber: ${item.documentNumber}`
                        },
                        {
                            icon: <HistoryToggleOffIcon key="item2"/>,
                            display: `BatchId: ${item.batchIdbatchId ? item.batchIdbatchId : 'Não registrado*'}`
                        },
                    ]}
                />
                {item.arquivos?.length > 0 &&
                    <DisplayDetailsData
                        key="files"
                        title='Arquivos'
                        openDefault
                        itens={item.arquivos.map((arquivo) => {
                            return {
                                icon: <InsertDriveFileIcon key={arquivo.id}/>,
                                display: `Arquivo:  ${arquivo.filename}`,
                                endContent: <DownloadButton
                                    url={`${baseUrl}/download/${arquivo.id}`}
                                    buttonText={''} variant={'text'}
                                    filename={arquivo.filename}
                                    icon={<DownloadIcon/>}
                                />
                            }
                        })}
                    />
                }
            </List>
        </Popup>
    )
}